module.exports = __webpack_public_path__ + "assets/img/modal-avatar-15c14440.png";